import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { IEvaluationResume } from 'models/evaluation.model'
import {
  EvaluationResponseStatus,
  isFinished,
} from 'enum/evaluationResponseStatus.enum'
import Actions from './components/Actions'
import { EvaluationsColumns, prefixHeaders } from './constants'
import Status from './components/Status'
import Score from './components/Score'

type Data = IEvaluationResume

interface UseColumnsProps {
  onRefresh: () => void
}

export function useColumns({ onRefresh }: UseColumnsProps) {
  const { t } = useTranslation()
  type Column = {
    title: string
    key: EvaluationsColumns
    sorteable?: boolean
    width?: number
    hideable?: boolean
    position?: string
    render?: (...data: any) => any
  }

  const columns: Column[] = useMemo(
    () => [
      {
        title: t(`${prefixHeaders}.name`),
        key: EvaluationsColumns.name,
        hideable: false,
        width: 70,
        render: (_, { name }: Data) => <span>{name}</span>,
      },
      {
        title: t(`${prefixHeaders}.status`),
        key: EvaluationsColumns.status,
        width: 70,
        render: (_, value?: Data) => <Status status={value?.status} />,
      },
      {
        title: t(`${prefixHeaders}.score`),
        key: EvaluationsColumns.score,
        width: 70,
        render: (_, value?: Data) => {
          const evaluationResponse = value?.evaluationResponse

          const status = evaluationResponse?.status
          const finished = isFinished(status)
          if (!evaluationResponse || !finished) return '--'

          return (
            <Score
              score={evaluationResponse.totalScore || 0}
              maxScore={value.totalPossiblePoints}
              approved={evaluationResponse.approved}
            />
          )
        },
      },
      {
        title: '',
        key: EvaluationsColumns.action,
        width: 100,
        hideable: false,
        align: 'right',
        render: (id, evaluationResume: Data) => (
          <Actions evaluationResume={evaluationResume} onRefresh={onRefresh} />
        ),
      },
    ],
    [t, onRefresh]
  )
  return columns
}
